import styled from 'styled-components'

import { _XS_Medium, mainColors } from '../../styles'

export const Stat = styled.div`
  min-width: 48px;
  display: flex;
  gap: 3px;
  flex-direction: column;
  justify-content: center;
  color: ${mainColors.neutralExtremelyDark};
`

export const Label = styled.div`
  ${_XS_Medium};
  text-align: left;
`
